export function parseCurrencyAmountFieldValue(raw: unknown): number {
  if (raw === null || raw === undefined) {
    return 0;
  }
  const s = String(raw).trim();
  if (s === '') {
    return 0;
  }
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : 0;
}

export function toCurrencyAmountFieldString(value: number): string {
  const rounded = Math.round(value * 100) / 100;
  if (!Number.isFinite(rounded)) {
    return '';
  }
  return String(rounded);
}
